// extracted by mini-css-extract-plugin
export var body = "_c5-0";
export var sectionHeader = "_c5-4";
export var shortcutColumns = "_c5-2";
export var shortcutList = "_c5-1";
export var shortcutSection = "_c5-3";